import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FilterState } from '../../interfaces/filter-state';

@Injectable({
  providedIn: 'root'
})
export class FilterStateService<T extends { _id: string }> {

  private stateSubject = new BehaviorSubject<FilterState<T>>({
    services: [],
    statuses: []
  });

  readonly state$: Observable<FilterState<T>> = this.stateSubject.asObservable();

  constructor() { }


  setEntities(services: T[], statuses: T[]) {
    this.stateSubject.next({
      services,
      statuses
    });
  }

  setService(services: T[]) {
    this.stateSubject.next({
      ...this.currentState,
      services
    });
  }

  setStatus(statuses: T[]) {
    this.stateSubject.next({
      ...this.currentState,
      statuses
    });
  }

  get currentState(): FilterState<T> {
    return this.stateSubject.getValue();
  }


  addEntity(service: T, status: T) {
    const services = [...this.currentState.services, service];
    const statuses = [...this.currentState.statuses, status];
    this.stateSubject.next({ services, statuses });
  }

  removeEntity(service: string, status: string) {
    const services = this.currentState.services.filter(e => e._id !== service);
    const statuses = this.currentState.statuses.filter(e => e._id !== status);
    this.stateSubject.next({ services, statuses });
  }
}
